<template>
  <div class="full-bar">
    <div class="bar-new-1 horizontal layout">
      <div class="flex">
        <div class="bar-new-2" id="progress-bar-line" />
      </div>
      <div class="bar-new-3" id="progress-bar-3" />
    </div>
  </div>
</template>
<script>
import EvenBus from '@/eventBus'
import storage from '@/services/storage'
import { mapState } from 'vuex'
import QuizStatuses from '@/constants/QuizStatuses'

export default {
  data() {
    return {
      timeoutWarning: null,
    }
  },

  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slide: (state) => state.slide,
    }),
  },
  mounted() {
    EvenBus.$on('show-full-progress-bar-quiz', () => {
      const elmProgessBar = document.getElementById('progress-bar-line')
      elmProgessBar.style['animation-duration'] = '0s'
    })
    EvenBus.$on('restart-progress-bar-quiz', () => {
      this._runProgessBar()
    })
    EvenBus.$on('stop-progress-bar-quiz', () => {
      this.stopProgressBar()
    })
    this._runProgessBar()
  },
  destroyed() {
    EvenBus.$off('restart-progress-bar-quiz')
    EvenBus.$off('stop-progress-bar-quiz')
    EvenBus.$off('show-full-progress-bar-quiz')
    if (document.getElementById('progress-bar-line')) {
      document.getElementById('progress-bar-line').classList.remove('warning')
    }
    if (this.timeoutWarning) {
      clearTimeout(this.timeoutWarning)
      this.timeoutWarning = null
    }
  },
  methods: {
    stopProgressBar() {
      const elmProgessBar = document.getElementById('progress-bar-line')
      if (elmProgessBar) {
        elmProgessBar.style['animation-play-state'] = 'paused'
      }
      if (this.timeoutWarning) {
        clearTimeout(this.timeoutWarning)
        this.timeoutWarning = null
      }
    },
    _runProgessBar() {
      if (this.presentation.audiencePacing) {
        const answeredSlideIds = storage.getValueByPresentation(this.presentation.id, 'answeredSlideIds', [])
        if (answeredSlideIds.includes(this.slide.id)) {
          return
        }
      }
      if (this.slide.quizStatus === QuizStatuses.RESULT_SCREEN) {
        // don't need to run quiz timer when it's answered
        return
      }
      let startTime = 0
      if (this.presentation.audiencePacing) {
        startTime = new Date().getTime() + this.slide.timeToAnswer * 1000
      } else {
        startTime = new Date().getTime() + this.$store.state.countdownTimeToAnswer * 1000
      }
      const countTimeToAnswer = parseInt((startTime - new Date().getTime()) / 1000, 10)
      const countToAnswer = parseInt(((this.$store.state.slide.timeToAnswer - countTimeToAnswer) / this.$store.state.slide.timeToAnswer) * 100, 10)

      const elmProgessBar = document.getElementById('progress-bar-line')
      const elmProgessBarDefault = document.getElementById('progress-bar-3')
      if (elmProgessBarDefault) {
        elmProgessBarDefault.style.width = `${countToAnswer}%`
      }
      if (elmProgessBar) {
        if (countTimeToAnswer > 0) {
          elmProgessBar.style.animationDuration = `${countTimeToAnswer}s`
        }
      }
      if (countToAnswer !== 100) {
        if (countToAnswer > 67) {
          elmProgessBar.classList.add('warning')
        } else {
          const timeWarning = (countTimeToAnswer - this.$store.state.slide.timeToAnswer / 3) * 1000
          if (
            this.slide.quizStatus !== QuizStatuses.RESULT_SCREEN
          ) {
            this.timeoutWarning = setTimeout(() => {
              if (this.slide.quizStatus !== QuizStatuses.RESULT_SCREEN) {
                elmProgessBar.classList.add('warning')
              }
              this.timeoutWarning = null
            }, timeWarning)
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.full-bar {
  background-color: #f1f1f1;
  border: 1px solid #fff;
  border-radius: 15px;
}

.bar-new-1 {
  background: #f1f1f1;
  height: 12px;
  border-radius: 15px;
}

.bar-new-2 {
  animation-name: progress-bar;
  animation-timing-function: linear;
  background: $primary-color;
  box-sizing: border-box;
  height: 100%;
  width: 0;
  border-radius: 15px;

  &.warning {
    background-color: #FFA826;
  }
}

#progress-bar-3 {
  height: 12px;
  background-color: #f1f1f1;
  width: 0;
  border-radius: 15px;
}

@keyframes progress-bar {
  from {width: 100%;}
  to {width: 0%;}
}
</style>
